<template>
    <div class="petri-box">
        <Title :title="detil.name" :url="`${domianURL}/${detil.icoOne}`" />
        <div class="bg-pert">
            <img :src="`${domianURL}/${detil.pic}`" alt="" />
        </div>
        <Menu v-if="!isother" />
        <Othermenu v-else />
    </div>
</template>

<script>
import Menu from "@/components/menu.vue";
import Othermenu from "@/components/othermenu.vue";
import Title from "@/components/title.vue";
import { getAction } from "@/api/manage.js";

export default {
    created() {
        this.loadata();
    },
    updated() {
        if(this.$route.query.id == '1357260382288248834'){
            this.isother = true
        }
    },
    components: {
        Menu,
        Title,
        Othermenu
    },
    data() {
        return {
            detil: {},
            isother: false,
        };
    },
    watch: {
        $route: {
            handler(value) {
                this.loadata();
                if(value.query.id == '1357260382288248834'){
                    this.isother = true
                }
            },
            deep: true,
        },
    },
    methods: {
        loadata() {
            getAction("/sys/category/queryById", {
                id: this.$route.query.id,
            }).then((res) => {
                if (res.success) {
                    this.detil = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.petri-box {
    .bg-pert {
        img {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            -webkit-animation: scale-in-center 0.5s
                cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
            animation: scale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
                both;
        }
    }
}
</style>
